/**
 * Build a Stripchat outbound URL that includes surface + device p1 attribution.
 *
 * StripCash groupP1 is populated from the `p1` query-param on the outbound click.
 * Stripchat's API clickUrl already contains path + userId — we only append p1.
 *
 * Surfaces:
 *   icg-homepage-sc-desktop
 *   icg-homepage-sc-mobile
 *   icg-category-sc-desktop
 *   icg-category-sc-mobile
 *
 * @param {string} rawClickUrl - The clickUrl from the Stripchat API (m.clickUrl)
 * @param {'homepage'|'category'} surface
 * @returns {string} URL with p1 appended / overwritten
 */
export function buildStripchatClickUrl(rawClickUrl, surface) {
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;
  const device = isMobile ? 'mobile' : 'desktop';
  const p1 = `icg-${surface}-sc-${device}`;

  try {
    const url = new URL(rawClickUrl);
    url.searchParams.set('p1', p1);
    return url.toString();
  } catch (e) {
    // Malformed URL — fall back to raw string append
    const sep = rawClickUrl.includes('?') ? '&' : '?';
    return `${rawClickUrl}${sep}p1=${p1}`;
  }
}
